import { object, string } from 'yup';

export default object().shape({
    Email:
        string()
            .email('INVALID_EMAIL')
            .required('REQUIRED')
});
